import { Navigate, NavLink, Outlet } from 'react-router-dom'
import { PageHeader } from '../../components/ui'
import { useMe } from '../../hooks/useMe'

export function AdminLayout() {
  const me = useMe()
  if (!me.data?.is_admin) return <Navigate to="/studio" replace />
  return (
    <>
      <PageHeader title="Admin" subtitle="Platform health, usage and spend, users, billing, provider keys and the job queue." />
      <nav className="tabs">
        <NavLink to="/studio/admin" end>Overview</NavLink>
        <NavLink to="/studio/admin/usage">Usage</NavLink>
        <NavLink to="/studio/admin/users">Users</NavLink>
        <NavLink to="/studio/admin/billing">Billing</NavLink>
        <NavLink to="/studio/admin/providers">Providers</NavLink>
        <NavLink to="/studio/admin/jobs">Jobs</NavLink>
        <NavLink to="/studio/admin/audit">Audit</NavLink>
      </nav>
      <Outlet />
    </>
  )
}
